import { HashedUrl } from '../infra/HashedUrl'
import { stringifyQueryString } from '../infra/queryString'

export function goToLogin() {
  if (!window.location.href.includes('/#/login')) {
    window.location.href = `/#/login?${stringifyQueryString({
      href: HashedUrl.fromCurrentHref().pathname,
    })}`
  }
}
